<div
  [formGroup]="getFormGroup()"
  [class.oneline-control]="getOneLineControl()"
  [class]="this.getStyleClass()"
  [class.oversize-container-behavior]="
    getInputType() === InputTypeValue.oversize
  "
>
  <label
    *ngIf="!this.getIsFilterInput()"
    class="control-label d-flex bs-label"
    [class.th-text-main]="!this.getIsSummaryType()"
    [class.flex-fill]="this.getTextOrientation() === 'right'"
    [class.oneline-label-control]="getOneLineControl()"
    [class.th-text-gray-paragraphs]="this.getIsSummaryType()"
    [class.fw-bold]="!this.getIsSummaryType()"
    [class.summary-label-control]="this.getIsSummaryType()"
    [class.align-items-center]="this.getInputType() === InputTypeValue.oversize"
  >
    {{ getLabelValue() }}
    <span class="required-span ms-1" *ngIf="getRequired()">*</span>

    <div
      *ngIf="
        this.getTooltipMessage() !== '' &&
        getInputType() === InputTypeValue.oversize
      "
      class="tooltip-container-oversized d-flex align-items-center"
      (click)="this.changeTooltipWindowState()"
      (mouseenter)="this.isTooltipShown = true"
      (mouseleave)="this.isTooltipShown = false"
    >
      <div class="tooltip-icon-container">
        <object
          [data]="this.tooltipIconPath | safeUrl"
          type="image/svg+xml"
          [width]="this.tooltipIconWidth"
          [height]="this.tooltipIconHeight"
        ></object>
      </div>

      <!-- tooltip window for normal tooltip -->
      <div
        class="tooltip-message-window th-bg-dark-gray"
        [class.tooltop-message-window-right]="
          this.getTooltipPosition() === this.tooltipPositionEnum.right ||
          this.getTooltipPosition() === ''
        "
        [class.tooltop-message-window-left]="
          this.getTooltipPosition() === this.tooltipPositionEnum.left
        "
        *ngIf="this.isTooltipShown"
      >
        <span class="th-text-white bs-paragraph">{{
          this.getTooltipMessage()
        }}</span>
      </div>
    </div>
  </label>

  <div
    [ngClass]="{
      'w-100': this.getType() !== typeEnum.Summary
    }"
    [class.summary-input-text-general-container]="this.getIsSummaryType()"
  >
    <!-- regex tooltip -->
    <div *ngIf="this.getRegexComponents().length > 0 && this.isFocus">
      <div
        class="th-bg-white regex-tooltip"
        [ngClass]="{
          'regex-tooltip-left': this.isMedium,
          'regex-tooltip-bottom ': this.isSmall || this.isExtraSmall
        }"
      >
        <div class="regex-content-container">
          <h3 *ngIf="this.getTooltipMessage()" class="bs-h3 th-text-main">
            {{ this.getTooltipMessage() }}:
          </h3>
          <div
            *ngFor="let regexComponent of this.getRegexComponents()"
            class="regex-component"
          >
            <div class="d-flex align-items-center">
              <object
                [data]="
                  this.getRegexTooltipIcon(regexComponent.getIsValid())
                    | safeUrl
                "
                type="image/svg+xml"
                [width]="this.tooltipIconWidth"
                [height]="this.tooltipIconHeight"
              ></object>
              <span
                class="bs-paragraph"
                [class.th-text-dark-gray]="!regexComponent.getIsValid()"
                [class.th-text-gray-paragraphs]="regexComponent.getIsValid()"
              >
                {{ regexComponent.getMessage() }}
              </span>
            </div>
          </div>
        </div>
        <div
          class="th-bg-white tooltip-arrow"
          [ngClass]="{
            'tooltip-arrow-left': this.isMedium,
            'tooltip-arrow-bottom': this.isExtraSmall || this.isSmall
          }"
        ></div>
      </div>
    </div>

    <!-- input text -->
    <div>
      <!-- this label will be hide if the input is of type filter-input-text -->
      <div
        [class.input-group-width]="getReadOnly()"
        [ngClass]="
          getIsSummaryType()
            ? 'input-group bs-input-div th-bg-input'
            : 'input-group bs-input-div th-bg-input'
        "
        [class.th-input-border]="
          !this.getIsFilterInput() && !this.getIsSummaryType()
        "
        [class.oneline-input-control]="
          getOneLineControl() && getInputType() !== InputTypeValue.oversize
        "
        [class.summary-input-div-control]="this.getIsSummaryType()"
        [class.th-input-alert]="!this.getIsValid()"
        [class.d-flex]="this.getIsFilterInput()"
        [class.align-items-center]="
          this.getInputType() === InputTypeValue.clipboard
        "
      >
        <input
          [type]="getIsPassword() ? 'password' : 'text'"
          [ngClass]="
            getIsSummaryType()
              ? 'form-control bs-input-complete bs-input th-bg-input th-text-dark-gray bs-text-roboto th-text-main'
              : 'form-control bs-input-complete bs-input th-bg-input th-text-dark-gray'
          "
          [class.form-control-read-only]="getReadOnly()"
          (focus)="this.isFocus = true"
          (blur)="this.isFocus = false"
          [class.input-with-icon]="this.getInputIcon().length > 0"
          [class.active-input]="this.getIsActive()"
          [class.th-bg-input-alert]="!this.getIsValid()"
          [disabled]="getReadOnly()"
          [class.th-bg-disabled]="getReadOnly()"
          [class.summary-input]="this.getIsSummaryType()"
          [name]="getModelId()"
          [id]="'txt_' + getId()"
          [style]="'text-align:' + getTextOrientationBasedType()"
          [formControlName]="getModelId()"
          (keyup.enter)="onInputEnter()"
          (keyup)="onKeyUp($event)"
          (input)="onInputChange($event.target.value)"
          [pattern]="getPattern()"
          [required]="getRequired()"
          #inputText
          #el
          [readonly]="getReadOnly()"
          [placeholder]="getPlaceHolder()"
          [maxLength]="getLength()"
          [class.filter-input]="this.getIsFilterInput()"
          [class.oversize-input]="getInputType() === InputTypeValue.oversize"
          [class.clipboard-input]="getInputType() === InputTypeValue.clipboard"
        />

        <i
          *ngIf="getInputType() === InputTypeValue.clipboard"
          class="clipboard-button fa fa-clone fa-lg bold-clipboard clipboard-input"
          (click)="copyToClipboard()"
          aria-hidden="true"
        >
        </i>

        <div
          class="clipboard-tooltip-container d-flex align-items-center"
          *ngIf="this.isClipBoardShown"
        >
          <div class="clipboard-tooltip-message-window th-bg-confirmation">
            <i class="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
            <span class="th-text-white bs-paragraph">
              �Copiado al portapapeles con �xito!</span
            >
          </div>
        </div>

        <!-- normal tooltip -->
        <div
          *ngIf="
            this.getTooltipMessage() !== '' &&
            this.getRegexComponents().length === 0 &&
            getInputType() !== InputTypeValue.oversize
          "
          [class.tooltip-container]="!this.getIsSummaryType()"
          [class.tooltip-container-summary]="this.getIsSummaryType()"
          class="d-flex align-items-center"
          (click)="this.changeTooltipWindowState()"
          (mouseenter)="this.isTooltipShown = true"
          (mouseleave)="this.isTooltipShown = false"
        >
          <div class="tooltip-icon-container">
            <object
              [data]="this.tooltipIconPath | safeUrl"
              type="image/svg+xml"
              [width]="this.tooltipIconWidth"
              [height]="this.tooltipIconHeight"
            ></object>
          </div>

          <!-- tooltip window for normal tooltip -->
          <div
            class="tooltip-message-window th-bg-dark-gray"
            [class.tooltop-message-window-right]="
              this.getTooltipPosition() === this.tooltipPositionEnum.right ||
              this.getTooltipPosition() === ''
            "
            [class.tooltop-message-window-left]="
              this.getTooltipPosition() === this.tooltipPositionEnum.left
            "
            *ngIf="this.isTooltipShown"
          >
            <span class="th-text-white bs-paragraph">{{
              this.getTooltipMessage()
            }}</span>
          </div>
        </div>

        <!-- for filter-container inputs -->
        <div
          class="input-group-append tooltip-icon-container"
          *ngIf="this.getIsFilterInput()"
          [class.filter-icon]="this.getIsFilterInput()"
          [class.th-bg-input-alert]="!this.getIsValid()"
          [class.background-cancel-button]="this.getIsActive()"
        >
          <span
            class="filter-button w-100 h-100 d-flex justify-content-center align-items-center"
            [class.th-bg-input-alert]="!this.getIsValid()"
            *ngIf="!this.getIsActive()"
            (click)="onInputEnter()"
          >
            <i class="fa fa-search"></i>
          </span>

          <span
            class="active-input filter-button w-100 h-100 d-flex justify-content-center align-items-center"
            *ngIf="this.getIsActive()"
            [class.th-bg-input-alert]="!this.getIsValid()"
            (click)="onInputEnter(true)"
          >
            <i class="fa fa-times"></i>
          </span>
        </div>

        <!-- It's container of the icon of the inputs. -->
        <div
          class="bs-icon-div th-input-icon th-bg-input"
          *ngIf="this.getInputIcon().length > 0"
        >
          <span
            class="input-group-text bs-icon th-bg-input"
            [class.th-bg-input-alert]="!this.getIsValid()"
            [class.th-bg-disabled]="getReadOnly()"
          >
            <i class="{{ this.getInputIcon() }}"></i>
          </span>
        </div>
      </div>
    </div>
  </div>

  <small
    class="help-block bs-error th-text-alert"
    [class.col-sm-10]="getOneLineControl()"
    [class.pull-right]="getOneLineControl()"
    *ngIf="!this.getIsValid()"
  >
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    {{ getRequiredMessage() }}
  </small>
</div>
